// extracted by mini-css-extract-plugin
export default {"shiftWrapper":"ShiftWrapper_shiftWrapper__bfzgD","shiftItem":"ShiftWrapper_shiftItem__BVwzN","shiftLabel":"ShiftWrapper_shiftLabel__b8823"};